import { Loader2 } from 'lucide-react';

interface ConfirmDeleteActionsProps {
  /** Handler for the cancel button (verbatim from the call site). */
  onCancel: () => void;
  /** Handler for the confirm/delete button (verbatim from the call site). */
  onConfirm: () => void;
  /** Disabled + loading flag for the confirm button. */
  loading: boolean;
  /** Label for the cancel button. */
  cancelLabel?: string;
  /** Label for the confirm button. */
  confirmLabel?: string;
  /**
   * Spinner rendering style:
   * - 'inline' (default): confirm button keeps `flex items-center gap-2`, renders
   *   `{loading && <Loader2 />}` followed by the label (label always present).
   * - 'replace': confirm button has no flex classes and renders
   *   `{loading ? <Loader2 /> : label}` (spinner replaces the label).
   */
  spinnerMode?: 'inline' | 'replace';
}

export default function ConfirmDeleteActions({
  onCancel,
  onConfirm,
  loading,
  cancelLabel = 'Cancel',
  confirmLabel = 'Delete',
  spinnerMode = 'inline',
}: ConfirmDeleteActionsProps) {
  return (
    <div className="flex items-center justify-end gap-3">
      <button
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
      >
        {cancelLabel}
      </button>
      {spinnerMode === 'inline' ? (
        <button
          onClick={onConfirm}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 flex items-center gap-2"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {confirmLabel}
        </button>
      ) : (
        <button
          onClick={onConfirm}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : confirmLabel}
        </button>
      )}
    </div>
  );
}
